<template>
  <div
    id="g-recaptcha"
    class="g-recaptcha"
    data-size="invisible"
    data-badge="inline"
    :data-sitekey="sitekey">
  </div>
</template>

<script>
export default {
  name: 'Recaptcha.vue',
  data() {
    return {
      sitekey: '6LeJBKgZAAAAADQB0mQo20UADO9s_V9w7d2FJ3LJ',
      widgetId: 0,
    };
  },
  methods: {
    execute() {
      window.grecaptcha.execute(this.widgetId);
    },
    reset() {
      window.grecaptcha.reset(this.widgetId);
    },
    render() {
      if (window.grecaptcha) {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: (response) => {
            // reset the recaptcha widget so you can execute it again
            this.reset();
            // emit an event called verify with the response as payload
            this.$emit('verify', response);
          },
        });
      }
    },
  },
  mounted() {
    // render the recaptcha widget when the component is mounted
    setTimeout(() => {
      this.render();
    }, 1000);
  },
};
</script>
